const EMAIL_KEY = 'lt_user_email'
const MODE_KEY = 'lt_mode'
const TEAM_KEY = 'lt_team_name'
const MODULES_KEY = 'lt_module_filter'
const EMAIL_RE = /^[^@]+@kainos\.com$/i

export type ReviewMode = 'individual' | 'team'

export function getStoredEmail(): string | null {
  return localStorage.getItem(EMAIL_KEY)
}

export function setStoredEmail(email: string): void {
  localStorage.setItem(EMAIL_KEY, email.trim().toLowerCase())
}

export function clearStoredEmail(): void {
  localStorage.removeItem(EMAIL_KEY)
}

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim())
}

export function getStoredMode(): ReviewMode {
  const val = localStorage.getItem(MODE_KEY)
  if (val === 'individual' || val === 'team') return val
  return 'individual'
}

export function setStoredMode(mode: ReviewMode): void {
  localStorage.setItem(MODE_KEY, mode)
}

export function getStoredTeamName(): string | null {
  return localStorage.getItem(TEAM_KEY)
}

export function setStoredTeamName(name: string): void {
  localStorage.setItem(TEAM_KEY, name.trim())
}

export function clearTeamSettings(): void {
  localStorage.removeItem(MODE_KEY)
  localStorage.removeItem(TEAM_KEY)
}

export function clearAllUserSettings(): void {
  localStorage.removeItem(EMAIL_KEY)
  localStorage.removeItem(MODE_KEY)
  localStorage.removeItem(TEAM_KEY)
}

export function getStoredModules(): string[] {
  const val = localStorage.getItem(MODULES_KEY)
  if (!val) return []
  try { return JSON.parse(val) } catch { return [] }
}

export function setStoredModules(modules: string[]): void {
  if (modules.length === 0) {
    localStorage.removeItem(MODULES_KEY)
  } else {
    localStorage.setItem(MODULES_KEY, JSON.stringify(modules))
  }
}
